import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';

import { colors } from '../../../styles/colors';
import { getOtherIcons, ZeeFontBold } from '../../../styles/font';
import { flex } from '../../../styles/utils';
import { OtherIconsSet } from '../../../utils/constants/IconsConstants';

export const active = css`
  background-color: ${colors.PrimaryWhiteColorAlpha06};
  z-index: 1;
`;
export const activeBox = css`
  border-color: ${colors.PurpleLight};
`;

export const Row = styled.div`
  width: 100%;
  ${flex('row', 'start', 'center')};
  border-radius: 8px;
  padding: 0px;
  border-top: 1px solid ${colors.AppBgColor};
  border-bottom: 1px solid ${colors.AppBgColor};
  &:hover {
    background-color: ${colors.PrimaryWhiteColorAlpha06};
    label div:last-of-type {
      border-color: ${colors.PurpleLight};
    }
  }
`;

export const Label = styled.label`
  width: 100%;
  padding: 12px;
  cursor: pointer;
  ${flex('row', 'space-between', 'center')};
  ${ZeeFontBold(14, 15)};
`;

export const commonName = css`
  padding-left: 20px;
  color: ${rgba(colors.NavMenuTextColor, 0.5)};
`;

export const langName = css`
  padding-left: 18px;
`;

export const dot = css`
  background: ${colors.white};
  border-radius: 50%;
  height: 6px;
  width: 6px;
`;

export const languageContainer = css`
  ${flex('row', 'flex-start', 'center')};
`;

export const CheckBox = styled.input`
  display: none;
`;

export const checkBoxOuter = css`
  border: 1px solid ${colors.RadioCheckBorderColor};
  border-radius: 2px;
  height: 14px;
  width: 14px;
  margin: 4px 0px;
  padding-left: 2px;
`;

export const checkIcon = css`
  font-size: 10px;
  ${flex('row', 'center', 'center')};
  ${getOtherIcons(OtherIconsSet.CHECK_MARK)};
  color: ${colors.RadioCheckBorderColor};
  &:before {
    margin-left: -1px;
  }
`;
